var Config = {
    initialized: false,
    appVersion: "1.3",
    wsUrl: "/api/antifrogen",
    authenticationToken: "",
    emailCharLimit: 189,
    init() {
        if (this.initialized) return;
        
        this.wsUrl = this.getElementValue("wsurl", this.searchWsUrl);
        this.authenticationToken = this.getElementValue("authentication-token", this.authenticationToken);
        this.emailCharLimit = this.getElementValue("emailcharlimit", this.emailCharLimit)
        
        this.initialized = true;
    },
    getElementValue(id, defaultValue) {
        var el = document.getElementById(id);
        if (el) return el.value || defaultValue;
        else return defaultValue;
    }
};

export default Config;